export default {
  setType(state, payload) {
    state.type = payload
  },
  setFilters(state, payload) {
    state.getFilters = payload
  },
  setXAxis(state, payload) {
    state.x_axis = payload
  },
  setActiveContextFilters(state, payload) {
    state.activeContextFilters = { ...state.activeContextFilters, ...payload }
  }
}
